<template>
  <div id="logsActivity">
    <v-navigation-drawer v-model="drawer" width="450" right absolute temporary>
      <v-toolbar color="rgb(4, 35, 51)" dark>
        <v-toolbar-title>Histórico de atividade</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="drawer = !drawer" class="ml-4 mr-0">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-timeline dense clipped two-line id="timeline">
        <v-timeline-item class="pb-4 pr-2" color="rgba(4,35,51,.8)" large>
          <template v-slot:icon>
            <v-icon color="#FFF">mdi-timer-sand</v-icon>
          </template>
          <strong>Suas atividades na tela de Compras</strong>
          <div class="caption">
            Aperte em
            <v-icon>mdi-restart</v-icon>
            caso deseje refazer uma atividade
          </div>
        </v-timeline-item>
        <v-timeline-item
          v-for="item in items"
          :key="item.id"
          fill-dot
          class="pt-4 pb-4 pr-2"
          :color="color(item)"
          :style="activeRow(item)"
        >
          <template v-slot:icon>
            <v-btn
              @click="refazerAtividade(item)"
              icon
              :disabled="!item.is_reset ? true : false"
            >
              <v-icon v-if="!item.is_reset">mdi-restart-off</v-icon>
              <v-icon color="#FFF" v-else>mdi-restart</v-icon>
            </v-btn>
          </template>

          <strong class="fs-11">{{ item.log_name }}</strong>
          <div class="caption">
            {{ item.created_at }}
          </div>
        </v-timeline-item>
      </v-timeline>
    </v-navigation-drawer>
  </div>
</template>

<script>
import LogsAPI from "./../../api/activityLog";

export default {
  props: ["abrirHistorico"],

  data: () => ({
    drawer: false,
    items: [],
    itemRefeito: "",
  }),

  watch: {
    abrirHistorico() {
      if (this.abrirHistorico) {
        this.drawer = this.abrirHistorico;
        this.buscarHistorico();
      }
    },
    drawer() {
      if (!this.drawer) this.$emit("fecharHistorico", false);
    },
  },

  methods: {
    color(item) {
      if (!item.is_reset) {
        return "rgba(0,0,0,.2)";
      } else {
        return "rgba(4,35,51,.7)";
      }
    },

    activeRow(item) {
      return item.id == this.itemRefeito ? "background: rgba(0,0,0,.09" : "";
    },

    refazerAtividade(log) {
      log.function = log.subject_type.replace("App\\Controllers\\", "");
      this.$store.dispatch("activityLog/setLog", log);

      this.itemRefeito = log.id;
      this.drawer = !this.drawer;
    },

    buscarHistorico() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        LogsAPI.getActivityLog(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.items = response.data.logs;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
  },
};
</script>

<style scoped>
#timeline {
  max-height: calc(-64px + 100vh);
  overflow-y: auto;
  margin-left: -15px;
}
.fs-11 {
  font-size: 11.5pt;
}
</style>
